import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

/**
 * Small inline toggle used near every "Add product" select in orders/receptions.
 * When ON, the dropdown hides products already present in the current
 * order/reception. When OFF, the full supplier catalog is shown (so the user
 * can deliberately add the same SKU twice, e.g. at a different price).
 *
 * The state lives in OrdersTab.jsx and is persisted in localStorage so the
 * preference survives reloads and is shared by all 4 add-product locations.
 */
export default function HideAddedToggle({ checked, onCheckedChange, testid = 'hide-added-toggle' }) {
    const id = `${testid}-id`;
    return (
        <div className="flex items-center gap-1.5 whitespace-nowrap shrink-0">
            <Switch
                id={id}
                checked={!!checked}
                onCheckedChange={onCheckedChange}
                className="data-[state=checked]:bg-emerald-500"
                data-testid={testid}
            />
            <Label htmlFor={id} className="text-[11px] text-slate-500 cursor-pointer select-none">
                Masquer déjà ajoutés
            </Label>
        </div>
    );
}
